import { render, staticRenderFns } from "./welcomesite.vue?vue&type=template&id=4b48a339"
import script from "./welcomesite.vue?vue&type=script&lang=js"
export * from "./welcomesite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports